module.exports = __webpack_public_path__ + "media/images/share-75b2b316ab6402e843ed3cafdf38d337.svg";